// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend) // load translations using http backend
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next
  .init({
    // lng: "fr",
    // fallbackLng: "fr",
    // debug: true,
    ns: ["common"], // specify namespaces
    defaultNS: "common",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // load translations from public/locales folder
    },
    lngs: ["fr", "en", "de", "es"],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
